let ContactoHelper = function () {

    /**
     * Elimina repetidos entre los contactos de clientes y les asigna las propuedades en tipo producto (telefono, mail) y tipo domicilio (domicilio) para ser utilizados en
     * la tabla de la pantalla "Cliente" ualá
     * @param {any} importe
     * @param {any} tasa
     */
    function _ComunicacionHelper(arregloComunicacion) {
        let arregloAux = [];

        for(var i = 0 ; i < arregloComunicacion.length ; i++){
                for(var x = 0 ; x < arregloComunicacion.length ; x++){
                    if(x!=i && arregloComunicacion[i].eliminar != true  && arregloComunicacion[i].Contacto == arregloComunicacion[x].Contacto && arregloComunicacion[i].TipoComunicacionId == arregloComunicacion[x].TipoComunicacionId ){
                        if(arregloComunicacion[i].TipoProducto != arregloComunicacion[x].TipoProducto) arregloComunicacion[i].TipoProducto = 'ambas'
                        arregloComunicacion[x].eliminar = true;
                    }
                }
        }
        arregloAux = arregloComunicacion.filter(medio=>!medio.eliminar);

        return arregloAux;
    }

    function _DomicilioHelper(arregloDomicilios, arregloCuentas) {
        let arregloAux = JSON.parse(JSON.stringify(arregloDomicilios));
        arregloCuentas.map(cuenta=>{
            if(cuenta.TipoProducto == "TC") cuenta.TipoProducto = "Tarjeta de crédito"
            if(cuenta.TipoProducto == "TP") cuenta.TipoProducto = "Tarjeta Prepaga"
        })

        arregloAux.map ( d=>d.TipoComunicacionId = 1)

        arregloCuentas.map(cuenta=>{
            arregloAux.map(dom=>{
                if(cuenta.DomicilioParticularId == dom.Id){
                    dom.EsDomicilioLegal = true;
                    if(!dom.TipoProducto ){
                        dom.TipoProducto = cuenta.TipoProducto
                    }else if(dom.TipoProducto != cuenta.TipoProducto){
                        dom.TipoProducto = "ambas"
                    } 
                } 
                if(cuenta.DomicilioCorrespondenciaId == dom.Id){
                    dom.EsDomicilioCorrespondencia = true;
                    if(!dom.TipoProducto ){
                        dom.TipoProducto = cuenta.TipoProducto
                    }else if(dom.TipoProducto != cuenta.TipoProducto){
                        dom.TipoProducto = "ambas"
                    } 
                } 
            })
        })

        return arregloAux;
    }

    return {
        ComunicacionHelper: function (arregloComunicacion) {
            return _ComunicacionHelper(arregloComunicacion);
        },
        DomicilioHelper: function (arregloDomicilios, arregloCuentas){
            return _DomicilioHelper(arregloDomicilios, arregloCuentas);
        }
    }
}

let contactoHelper = new ContactoHelper();
export default contactoHelper;

